module.exports = __webpack_public_path__ + "img/7_168.9bf3cf5d.png";